import { InnerLabelTextfield, TextField } from "components/commons";
import React from "react";
import { isPesoValid, formatNumber, parseNumber, isAmountValid } from "utils";

const InputAmount = ({
  className,
  onChange,
  innerLabel,
  decimalPlaces = 2,
  isPriceValue = false,
  prefix = "₱",
  onBlur,
  ...props
}) => {
  const componentProps = {
    ...props,
    className,
    onChange: (name, { value }) => {
      const min = props?.min;
      const max = props?.max;

      if (value === "") {
        onChange(name, { value });
        return;
      }

      if (value === "-" && (min === undefined || +min < 0)) {
        onChange(name, { value });
        return;
      }

      if (decimalPlaces === 0 && value.includes(".")) return;

      const parsed = Number(value);
      if (isNaN(parsed)) return;

      if (min !== undefined && parsed < +min) return;
      if (max !== undefined && parsed > +max) return;

      const isValid = isPriceValue
        ? isAmountValid(value, decimalPlaces)
        : isPesoValid(value, decimalPlaces);

      if (isValid || !isPriceValue) {
        onChange(name, { value });
      }
    },
    onBlur: (name, { value }) => {
      if (isNaN(value)) {
        return onChange(name, {
          value: "",
        });
      }

      if (onBlur) {
        onBlur(value);
      } else {
        if (value) {
          onChange(name, {
            value: `${formatNumber(value, decimalPlaces)}${!innerLabel ? "" : ""}`,
          });
        } else {
          onChange(name, { value: `${formatNumber(0, decimalPlaces)}` });
        }
      }
    },
    onFocus: () => {
      if (props.value) {
        const num = Number(parseNumber(props.value));
        onChange(props.name, { value: num || "" });
      }
    },
    helperText: props.message || "",
  };
  if (innerLabel) {
    return <InnerLabelTextfield {...componentProps} prefix={prefix ? prefix : "₱"} />;
  }
  return <TextField {...componentProps} />;
};

export default InputAmount;
